import React from 'react';
import { Card } from 'react-bootstrap';
import './SinglePill.css';

/**
 * SinglePill Component
 * 
 * Props:
 * - title (string): The title text for this pill.
 * - value (number | string): The numeric/stat value to display inside the circle.
 * - Icon (optional): A React icon component (e.g., FaBuilding).
 * - iconColor (string): Color for the top-right icon (default '#007bff').
 * - circleColor (string): Border color for the circle (default '#007bff').
 */
function SinglePill({ 
  title, 
  value, 
  Icon, 
  iconColor = '#007bff', 
  circleColor = '#007bff'
}) {
  return (
    <Card className="shadow-sm border-0 single-pill-card">
      <Card.Body className="single-pill-body">
        {/* Optional Icon at top-right */}
        {Icon && (
          <div className="single-pill-icon" style={{ color: iconColor }}>
            <Icon />
          </div>
        )}

        {/* Pill Title */}
        <Card.Title className="single-pill-title">{title}</Card.Title>
        
        {/* Circle with the Value */}
        <div 
          className="single-number-circle" 
          style={{ borderColor: circleColor }}
        >
          <span>{value}</span>
        </div>
      </Card.Body>
    </Card>
  );
}

export default SinglePill;
